import { render, staticRenderFns } from "./InfiniteScroll.vue?vue&type=template&id=96bc6b80&scoped=true&"
import script from "./InfiniteScroll.vue?vue&type=script&lang=js&"
export * from "./InfiniteScroll.vue?vue&type=script&lang=js&"
import style0 from "./InfiniteScroll.vue?vue&type=style&index=0&id=96bc6b80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bc6b80",
  null
  
)

export default component.exports